export default {
  "logoLink": "https://www.atfx.com/ar",//修改该参数请在/static/lang.js也需修改
  "FCA_License_No": "ترخيص هيئة رقابة السلوك المالي FCA رقم",//修改该参数请在/static/lang.js也需修改
  "headTtitle": "افتح حساب حقيقي لتداول العملات وعقود الفروقات | ATFX UK",//修改该参数请在/static/lang.js也需修改
  "topFixedBanner": "تعتبر المراهنة على فروق الأسعار و تداول عقود الفروقات أدوات معقدة وتنطوي على مخاطر مرتفعة بخسارة الأموال بشكل سريع نتيجة استخدام الرافعة المالية.  تخسر الغالبية العظمى من حسابات العملاء الأفراد الأموال عند تداول عقود الفروقات.  يجب أن تفكر فيما إذا كان بمقدورك تحمل المخاطر المرتفعة بخسارة أموالك.",//修改该参数请在/static/lang.js也需修改
  "topFixedBannerShort": "59.38٪ من حسابات المستثمرين الأفراد يخسرون المال عند تداول عقود الفروقات / رهانات الفروقات مع هذا المزود.",//修改该参数请在/static/lang.js也需修改
  "headDescription": "افتح حساب ATFX الحقيقي لتداول العملات وعقود الفروقات مع وسيط منظم ومرخص في المملكة المتحدة من هيئة التنظيم المالي FCA.,فروقات سعرية منخفضة ، رافعة مالية بنسبة 1: 200 ، منصة MT4 للتداول ، دعم العملاء على مدار الساعة. سجل لفتح حسابك الآن!",
  "policyBarClose": 'The Firm has taken the decision to cease providing services to retail clients, with immediate effect. We are therefore unable to accept any applications.<br />Services to professional clients will not be impacted. For professional applications please contact <a href="mailto:cs.uk@atfx.com">cs.uk@atfx.com</a>',
  "policyBar":'We use cookies to ensure you get the best experience on our website. By continuing to browse you accept our use of cookies. <a title="[Read more]" href="https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Cookies%20Policy%20EN.pdf" target="_blanck">[Read more]</a>',
  "policyBarButton":'Accept',
  "header": {
    "registration": "فتح الحساب",
    "personalDetails1": "البيانات الشخصية 1",
    "personalDetails2": "البيانات الشخصية 2",
    "financialDetails": "التفاصيل المالية",
    "Experience": "الخبرة",
    "Knowledge": "المعرفة",
    "Acknowledgements": "الإقرارات",
    "previewPage":"المعاينة",
    "liveTrading": "التداول الحقيقي"
  },
  footer:{ //修改该参数请在/static/lang.js也需修改
    "copyright":"جميع الحقوق محفوظة",
    "terms1":'<a href="https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Privacy%20Notice%20EN%2031.08.pdf" target="_blank" rel="noopener">سياسة الخصوصية</a>',
    "terms2":'<a href="https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Cookies%20Policy%20EN.pdf" target="_blank" rel="noopener">اتفاقية ملفات تعريف الارتباط</a>',
    "terms3":'<a href="https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Standard%20Terms%20of%20Business%20EN%20-%20V08.18.pdf" target="_blank" rel="noopener">الشروط و الأحكام</a>',
    "Legal":"ATFX مرخصة وخاضعه للتنظيم من قبل هيئة رقابة السلوك المالي (FCA) في المملكة المتحدة. رقم تسجيل FCA (760555). المكتب المسجل: الطابق الأول ، 32 كورنهيل ، لندن EC3V 3sg ، المملكة المتحدة. رقم الشركة 09827091",
    "riskWaring":'تحذير :الإستثمار عالي المخاطر: العقود مقابل الفروقات هي أدوات معقده وتاتي مع مخاطر عاليه من فقدان المال بشكل سريع بسبب الرافعة المالية. <strong>59.38٪ من حسابات المستثمرين بالتجزئة تخسر المال عند تداول العقود مقابل الفروقات مع هذا الموفر.</strong> يجب عليك ان تنظر فيما إذا كنت تفهم كيف تعمل العقود مقابل الفروقات وما إذا كان بإمكانك تحمل المخاطرة العالية بخسارة أموالك. يرجى قراءه سياسة <a title="Risk Disclosure Policy" href="https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Standard%20Terms%20of%20Business%20EN%20-%20V08.18.pdf" target="_blanck">  الإفصاح عن المخاطر كاملة.</a>.',
    "otherInfo":"المعلومات الموجودة علي هذا الموقع ليست موجهه للمقيمين في الولايات المتحدة أو بلجيكا أو اي دوله معينه خارج المملكة المتحدة وليست مخصصه للتوزيع أو الاستخدام من قبل اي شخص في اي بلد أو ولاية قضائية حيث يكون هذا التوزيع أو الاستخدام مخالفا إلى القانون أو اللوائح المحلية."
  },
  "headerMsg": {
    "personalDetails1": "البيانات الشخصية 1",
    "personalDetails2": "البيانات الشخصية 2",
    "financialDetails": "التفاصيل المالية",
    "experience": "الخبرة",
    "knowledge": "المعرفة",
    "acknowledgements": "الإقرارات"
  },
  "changeLanguage": "تغيير اللغة",
  "back": "العودة",
  "next": "التالي",
  "finish": "إنهاء",
  "personalDetails1": {
    "estimatedTime":"Estimated time to complete your registration is 5 minutes",
    "Gender": "جنس",
    "genderSelect": {
      "M": "السيد",
      "F": "السيدة",
      "O":"آخر"
    },
    "OtherGender":"جنس آخر",
    "Title": "اللقب",
    "titleSelect":{
      "Mr":"السيد",
      "Mrs":"السيدة",
      "Ms":"الآنسة",
      "Miss":"يغيب",
      "Dr":"الدكتور",
      "Other":"آخر"
    },
    "OtherTitle":"العنوان الآخر",
    "First_Name": "الاسم الأول",
    "Surname": "اللقب",
    "Email": "البريد الإلكتروني",
    "Email_Confirm": "تأكيد البريد الإلكتروني",
    "Lang": "لغة البريد الإلكتروني",
    "emailLanguages": {
      "ENG": "الإنجليزية",
      "CHT": "الصينية التقليدية",
      "CHS": "الصينية المبسطة",
      "ARA": "عربي",
      "ESP": "الإسبانية",
      "ITA": "الإيطالية",
      "GER": "ألمانية",
      "PTG": "البرتغالية"
    },
    "MT4_Currency":"عملة حساب التداول",
    "MT4CurrencySelect":{
      "USD":"(USD) دولار",
      "GBP":"(GBP) جنيه ",
      "EUR":"(EUR) يورو "
    },
    "Account_Type": "MT4 نوع الحساب",
    "Account_TypeSelect": {
      "CFDs": "CFDs",
      "SpreadBetting": "انتشار الرهان"
    },
    "Country": "بلد الإقامة",
    "countrySelect": {
      "USA": "United States of America",
      "HKG": "Hong Kong",
      "GBR":"المملكة المتحدة",
      "CHN":"الصين",
      "TWN":"تايوان",
      "ARE":"الإمارات العربية المتحدة",
      "ALB":"ألبانيا",
      "AND":"أندورا",
      "AIA":"أنغيلا",
      "ATG":"أنتيغوا وبربودا",
      "ARG":"الأرجنتين",
      "ARM":"أرمينيا",
      "ABW":"أروبا",
      "AUS":"أستراليا",
      "AUT":"النمسا",
      "AZE":"أذربيجان",
      "BHS":"الباهاما",
      "BHR":"البحرين",
      "BGD":"بنغلاديش",
      "BRB":"بربادوس",
      "BLR":"روسيا البيضاء",
      "BEL":"بلجيكا",
      "BLZ":"بليز",
      "BEN":"بنين",
      "BMU":"برمودا",
      "BOL":"بوليفيا",
      "BWA":"بوتسوانا",
      "BVT":"جزيرة بوفيت",
      "BRA":"البرازيل",
      "BRN":"بروناي دار السلام",
      "BGR":"بلغاريا",
      "BFA":"بوركينا فاسو",
      "BDI":"بوروندي",
      "KHM":"كمبوديا",
      "CMR":"الكاميرون",
      "CPV":"الرأس الأخضر",
      "CYM":"جزر كايمان",
      "CAF":"جمهورية أفريقيا الوسطى",
      "TCD":"تشاد",
      "CHL":"تشيلي",
      "CCK":"جزر كوكوس",
      "COL":"كولومبيا",
      "COM":"جزر القمر",
      "COK":"جزر كوك",
      "CRI":"كوستاريكا",
      "CIV":"كوت ديفوار",
      "HRV":"كرواتيا",
      "CUB":"كوبا",
      "CYP":"قبرص",
      "CZE":"التشيك",
      "DNK":"الدنمارك",
      "DJI":"جيبوتي",
      "DMA":"دومينيكا",
      "DOM":"جمهورية الدومنيكان",
      "EGY":"مصر",
      "SLV":"السلفادور",
      "ERI":"إريتريا",
      "EST":"استونيا",
      "ETH":"أثيوبيا",
      "FJI":"فيجي",
      "FIN":"فنلندا",
      "PYF":"بولينيزيا الفرنسية",
      "GAB":"الغابون",
      "GEO":"جورجيا",
      "DEU":"ألمانيا",
      "GHA":"غانا",
      "GIB":"جبل طارق",
      "GRC":"اليونان",
      "GRL":"الأرض الخضراء",
      "GRD":"غرينادا",
      "GLP":"جوادلوب",
      "GTM":"غواتيمالا",
      "GIN":"غينيا",
      "GNB":"غينيا بيساو",
      "HTI":"هايتي",
      "HMD":"جزر هيرد وماكدونالد",
      "HND":"هندوراس",
      "HUN":"اليونان",
      "ISL":"أيسلندا",
      "IND":"الهند",
      "IDN":"إندونيسيا",
      "IRL":"أيرلندا",
      "ISR":"إسرائيل",
      "ITA":"إيطاليا",
      "JAM":"جامايكا",
      "JPN":"اليابان",
      "JOR":"الأردن",
      "KAZ":"كازاخستان",
      "KEN":"كينيا",
      "KIR":"كيريباتي",
      "KOR":"جمهورية كوريا",
      "KWT":"الكويت",
      "KGZ":"قرغيزستان",
      "LVA":"لاتفيا",
      "LSO":"ليسوتو",
      "LBR":"ليبيريا",
      "LBY":"ليبيا",
      "LIE":"ليختنشتاين",
      "LTU":"ليتوانيا",
      "LUX":"لوكسمبورغ",
      "MAC":"ماكاو",
      "MDG":"مدغشقر",
      "MWI":"مالاوي",
      "MYS":"ماليزيا",
      "MDV":"جزر المالديف",
      "MLI":"مالي",
      "MLT":"مالطا",
      "MHL":"جزر مارشال",
      "MTQ":"مارتينيك",
      "MUS":"موريشيوس",
      "MYT":"مايوت",
      "MEX":"المكسيك",
      "MDA":"مولدوفا",
      "MCO":"موناكو",
      "MNG":"منغوليا",
      "MNE":"الجبل الأسود",
      "MSR":"مونتسيرات",
      "MAR":"المغرب",
      "MOZ":"موزمبيق",
      "NAM":"ناميبيا",
      "NRU":"ناورو",
      "NLD":"هولندا",
      "NCL":"كاليدونيا الجديدة",
      "NZL":"نيوزيلاندا",
      "NIC":"نيكاراغوا",
      "NER":"النيجر",
      "NGA":"نيجيريا",
      "NIU":"نيوي",
      "NFK":"جزيرة نورفولك",
      "NOR":"النرويج",
      "OMN":"سلطنة عمان",
      "PAK":"باكستان",
      "PSE":"فلسطين",
      "PRY":"باراغواي",
      "PER":"بيرو",
      "PHL":"الفلبين",
      "PCN":"بيتكيرن",
      "POL":"بولندا",
      "PRT":"البرتغال",
      "QAT":"قطر",
      "ROU":"رومانيا",
      "RUS":"روسيا",
      "RWA":"رواندا",
      "SHN":"سانت هيلانة",
      "KNA":"سانت كيتس ونيفيس",
      "LCA":"سانت لوسيا",
      "SPM":"سانت بيير وميكلون",
      "VCT":"سانت فنسنت وجزر غرينادين",
      "WSM":"ساموا",
      "SMR":"سان مارينو",
      "STP":"ساو تومي وبرينسيبي",
      "SAU":"المملكة العربية السعودية",
      "SEN":"السنغال",
      "SRB":"صربيا",
      "SYC":"سيشيل",
      "SLE":"سيراليون",
      "SGP":"سنغافورة",
      "SVK":"سلوفاكيا",
      "SVN":"سلوفينيا",
      "ZAF":"جنوب أفريقيا",
      "ESP":"إسبانيا",
      "SUR":"سورينام",
      "SJM":"سفالبارد وجان ماين",
      "SWZ":"سوازيلاند",
      "SWE":"السويد",
      "CHE":"سويسرا",
      "TJK":"طاجيكستان",
      "TZA":"تنزانيا",
      "THA":"تايلاند",
      "TLS":"تيمور الشرقية",
      "TGO":"توغو",
      "TON":"تونغا",
      "TTO":"ترينداد وتوباغو",
      "TUN":"تونس",
      "TUR":"تركيا",
      "TKM":"تركمانستان",
      "TCA":"جزر تركس وكايكوس",
      "TUV":"توفالو",
      "UKR":"أوكرانيا",
      "URY":"أوروغواي",
      "UZB":"أوزبكستان",
      "VUT":"فانواتو",
      "VAT":"الفاتيكان",
      "VEN":"فنزويلا",
      "VNM":"فيتنام",
      "WLF":"واليس وفوتونا",
      "ESH":"الصحراء الغربية",
      "ZMB":"زامبيا",
      "DZA": "Algeria",
      "AGO": "Angola",
      "BIH": "Bosnia-Herzegovina",
      "GMB": "Gambia",
      "GUY": "Guyana",
      "IRQ": "Iraq",
      "RKS": "Kosovo",
      "LBN": "Lebanon",
      "MKD": "Macedonia",
      "NPL": "Nepal",
      "PAN": "Panama",
      "PNG": "Papua New Guinea",
      "LKA": "Sri Lanka"
    }
  },
  "personalDetails2": {
    "Addr": "خط العنوان 1",
    "Addr2": "خط العنوان 2",
    "City": "البلدة / المدينة",
    "Postcode": "الرمز البريدي",
    "Building_Name": "رقم المبنى / الاسم",
    "Street": "شارع",
    "Province": "مقاطعة",
    "birthDate": "تاريخ الميلاد:",
    "birthYear": "السنة",
    "birthMonth": "الشهر",
    "birthSecond": "اليوم",
    "Nationality": "الجنسية",
    "isHavePass": "هل لديك جواز سفر",
    "PotSelect": {
      "havePot": "نعم",
      "noPot": "لا"
    },
    "NAT_ID": "جواز السفر",
    "Phone": "الهاتف",
    "countryPlace": "بلد الإقامة الضريبية",
    "TIN": "رقم التعريف الضريبي (TIN)",
    "Doc_Type": "نوع وثيقة الهوية",
    "idTypeSelect": {
      "POT": "جواز سفر",
      "IDC": "بطاقة هوية",
      "DRI": "رخصة قيادة"
    },
    "Doc_No": "رقم بطاقة الهوية",
    "bankCardType": "نوع البطاقة المصرفية",
    "bankCardTypeSelect": {
      "DR": "بطاقة ائتمانية",
      "CR": "بطاقة خصم"
    },
    "Addr_Country":"العنوان الدولة",
    "Bank_Card_No": "رقم البنك",
    "bankCardNoConfirm": "تأكيد رقم البنك",
    "Bank": "البنك",
    "bankSelect": {
      "ICBK": "INDUSTRIAL AND COMMERCIAL BANK OF CHINA",
      "ABOC": "AGRICULTURAL BANK OF CHINA",
      "PCBC": "CHINA CONSTRUCTION BANK CORPORATION",
      "BKCH": "BANK OF CHINA LIMITED",
      "CMBC": "CHINA MERCHANTS BANK",
      "COMM": "BANK OF COMMUNICATIONS",
      "MSBC": "CHINA MINSHENG BANKING CORPORATION, LIMITED",
      "EVER": "CHINA EVERBRIGHT BANK",
      "SPDB": "SHANGHAI PUDONG DEVELOPMENT BANK",
      "FJIB": "INDUSTRIAL BANK",
      "CIBK": "CITIC BANK CORPORATION LIMITED",
      "PSBC": "POSTAL SAVINGS BANK OF CHINA",
      "SZCB": "SHENZHEN DEVELOPMENT BANK CO., LTD",
      "GDBK": "CHINA GUANGFA BANK",
      "BOSH": "BANK OF SHANGHAI",
      "BJCN": "BANK OF BEIJING",
      "HXBK": "HUA XIA BANK",
      "other": "أخرى"
    },
    "OtherBank": "بنوك أخرى",
    "Beneficiary_Name": "أسم المستفيد",
    "SWIFT_Code": "رمز سويفت البنك",
    "Branch_Name": "اسم الفرع",
    "Bank_Addr": "عنوان الفرع",
    "Branch_Province": "مقاطعة الفرع",
    "Branch_City": "مدينة الفرع",
    "bankCardImg": "صورة البطاقة المصرفية",
    "IBAN_Code":"ترميز IBAN",
    "docFrontImgword": "صورة بطاقة الهوية (الوجه الأمامي)",
    "docBackImgword": "صورة بطاقة الهوية (الوجه الخلفي)",
    "addressUpload": "إثبات العنوان",
    "addressUpload2": "إثبات العنوان 2",
    "addressUploadTxt1": "الوثائق الثبوتية المتاحة: بشرط ألا يزيد تاريخها عن ثلاثة أشهر، فواتير الكهرباء / فواتير الغاز / كشف الحساب المصرفي / تصريح الإقامة / رخصة سكنية / بطاقة هوية / بطاقة التسجيل السكني (إذا لم يكن مقدم الطلب هو رب الأسرة، جنباً إلى جنب مع الحاجة لدمج هذه الوثائق مع صور الوثائق المقدمة في الصفحة 1)؛",
    "addressUploadTxt2": "لا يجوز تقديم وثيقة واحدة كإثبات لكلاً من الهوية ومحل الإقامة.",
    "docImgword1": "الوثيقة المرفقة 1",
    "docImgword2": "الوثيقة المرفقة 2",
    "docImgword3": "الوثيقة المرفقة 3",
    "docImgword4": "الوثيقة المرفقة 4",
    "docImgword5": "الوثيقة المرفقة 5",
    "fileUpload":{
      "imgtUpload": "رفع",
      "uploadFileArr": [{
        "labelTxt": "معرف الصورة 1",
        "ValidateNull": "يرجى الاختيار",
        "sizeLimit": "ID Image1 لا يمكن أن يتجاوز 5 ميغابايت!"
      }, {
        "labelTxt": "معرف الصورة 2",
        "ValidateNull": "يرجى الاختيار",
        "sizeLimit": "ID Image2 لا يمكن أن يتجاوز 5 ميغابايت!"
      }, {
        "labelTxt": "إثبات العنوان",
        "ValidateNull": "يرجى الاختيار",
        "sizeLimit": "يجب ألا يتجاوز حجم صورة إثبات العنوان 5 ميجابايت."
      },{
        "labelTxt": "إثبات العنوان 2",
        "ValidateNull": "يرجى الاختيار",
        "sizeLimit": "يجب ألا يتجاوز حجم صورة إثبات العنوان 5 ميجابايت."
      },{
        "labelTxt": "ملفات اخرى",
        "ValidateNull": "يرجى الاختيار",
        "sizeLimit": "لا يمكن أن يتجاوز حجم الملفات الأخرى 5 ميغابايت!"
      }],
      "addressUploadHtml": {
        "sizeLimit":"لا يمكن ان يتجاوز حجم الملف 5 ميجابيتس",
        "upload_your_documents":"تحميل الوثائق الشخصية الخاصة بك",
        "documents_not_ready":"وثائق غير جاهزة؟",
        "noe": "يجب علي مقدمي الطلبات تقديم صوره الهوية والعنوان للتحقق من هويتهم. علما بأن: فواتير الهاتف المحمول ، وفواتير بطاقات الائتمان ، أو اي فواتير الخدمات المتنقلة ؛ إيصالات التامين ؛ فاتورة لشراء جيده/الخدمات غير مقبولة.",
        "noe2":"لا يزال بإمكانك إكمال الطلب الخاص بك إذا لم يكن لديك المستندات المطلوبة في الوقت الحالي. ومع ذلك ، لن تكون قادرا علي التداول حتى نتلقى الوثائق المطلوبة.",
        "header1": "إثبات الهوية :(الحد الأدنى من المتطلبات)",
        "list1": "نحن بحاجه إلى نسخ ملونه من وثيقة الهوية/جواز السفر الصادرة عن الحكومة الاصليه.  نحن بحاجه إلى الجانبين الامامي والخلفي من بطاقة الهوية.",
        "header2": "إثبات العنوان: (اي $Logic من الخيارات التالية)",
        "list2": "<ol class='list-style-position:inside'><li>فاتورة المرافق (المياه/الكهرباء/الغاز) – صدرت في الأشهر الثلاثة الماضية.</li><li>Bank Statement issued in the past 3 months,</li><li>يمكننا قبول كتب الإقامة/الكتب الملكية بما في ذلك hukou الصينية – ولكن تخضع للمراجعة.</li><li>ويتعين توفير عقد إيجار ساري ، وفواتير للمرافق (الغاز/المياه/الكهرباء) ، سدد في الأشهر الثلاثة السابقة.</li><li>فاتورة ضريبية حديثة، إذا صدرت فقط في الأشهر الستة الماضية.</li><li>فاتورة هاتف أرضي ، صدرت في الأشهر الثلاثة الماضية.</li></ol>",
        "strongTxt":"<strong>كجزء من متطلباتنا التنظيمية ، قد نطلب وثائق إضافية فيما يتعلق بطلبك.</strong>"
      }
    },
    "IS_Politically_Person": "هل أنت شخص ذو نفوذ سياسي؟",
    "IS_Politically_Exposed":`الشخص ذو النفوذ السياسي هو شخص طبيعي أُوكِلت إليه أو كُلف بتولي مناصب عامة بارزة في الجمهورية أو أي بلد آخر، <br/>
                              أو كان شخص قريب الصلة بشخص ذو نفوذ سياسي، أو كان شخص معروف بأنه شريك مقرب للشخص ذو النفوذ السياسي:<br/>
                              شريطةً أن تعني "الوظيفة العامة البارزة" أي من الوظائف العامة التالية لأغراض هذا التعريف:<br/>
                              (أ) رؤساء الدول ورؤساء الحكومات والوزراء ونواب الوزراء أو الوزراء المساعدين؛<br/>
                              (ب) أعضاء البرلمان أو الهيئات التشريعية المماثلة؛<br/>
                              (ج) أعضاء مجالس إدارة الأحزاب السياسية؛<br/>
                              (د) أعضاء المحاكم العليا أو المحاكم الدستورية أو غيرها من الهيئات القضائية رفيعة المستوى، والتي لا تخضع قراراتها للاستئناف إلا في ظروف استثنائية؛<br/>
                              (هـ) أعضاء محاكم المدققين أو مجالس البنوك المركزية؛<br/>
                              (و) السفراء والقائمون بالأعمال والضباط ذوي الرتب القيادية في القوات المسلحة؛<br/>
                              (ز) أعضاء الهيئات الإدارية أو الإشرافية أو مجالس إدارات المؤسسات المملوكة للدولة؛<br/>
                              (ح) المديرين ونوابهم وأعضاء مجلس الإدارة أو من يشغلون وظيفة مماثلة في منظمة دولية؛<br/>
                              (ط) رئيس البلدية: شريطة ألا يشار في النقاط (أ) إلى أي وظيفة عامة على اعتبار <br/>
                              (ط) أن تُفهم على أنها تشمل الرتب المتوسطة أو الموظفين الأقل رتبة؛<br/>
                              يجوز أيضاً أن يشمل مفهوم "الأقارب من الدرجة الأولى للشخص ذو النفوذ السياسي" ما يلي:<br/>
                              (أ) الزوج، أو الشخص الذي يعتبر معادلاً للزوج، لشخص ذو نفوذ سياسي؛<br/>
                              (ب) الأطفال وأزواجهم، أو الأشخاص الذين يُعتبرون مكافئين للزوج، لشخص ذو نفوذ سياسي؛<br/>
                              (ج) والدي الشخص ذو النفوذ السياسي؛ وعلاوةً على ذلك، يشمل مفهوم "الأشخاص المعروفين بأنهم شركاء مقربين لشخص ذو نفوذ سياسي" الشخص الطبيعي:<br/>
                              (أ) المعروف بأن لديه ملكية أو منفعة مشتركة في كيانات قانونية أو ترتيبات قانونية، أو أي علاقات عمل وثيقة مع شخص ذو نفوذ سياسي؛ <br/>
                              (ب) شخص لديه ملكية أو منفعة في كيان قانوني أو ترتيبات قانونية معروف أنه تم وضعها لتحقيق منفعة فعلية لشخص ذو نفوذ سياسي.<br/>`,
    "IS_Politically_Person_Select": {
      "Y": "نعم",
      "N": "لا"
    },
  },
  "financialDetails": {
    "Emp_Status": "الحالة الوظيفية",
    "employmentStatusSelect": {
      "b": "موظف",
      "a": "مهنة حرة",
      "c": "طالب",
      "e": "متقاعد",
      "d": "لا يعمل"
    },
    "Freelance_OwnACompany": "تعمل لحسابك الخاص / تملك شركة",
    "Freelance_OwnACompany_select": {
      "0": "أعمل لحسابي الخاص",
      "1": "أمتلك شركة"
    },
    "Position": "الوظيفة",
    "FD_Position_select": {
      "0": "منصب الإدارة التنفيذية على سبيل المثال ، CEO ، CFO ، CIO",
      "1": "كبير المديرين",
      "2": "المدير العام / الأوسط",
      "3": "المشرف",
      "4": "كاتب",
      "5": "موظف",
      "6": "موظف حديث",
      "7": "غير ذلك (يرجى التحديد)"
    },
    "Employer": "اسم الشركة",
    "Biz_Nature": "طبيعة العمل",
    "financialRegulator": "قيمة محفظتك المالية",
    "financialRegulatorSelect": {
      "Y": "نعم",
      "N": "لا"
    },
    "Industry_Sector": "الصناعة / القطاع",
    "Industry_Sector_select": {
      "0": "المحاسبة",
      "1": "الإعلان / وسائل الإعلام",
      "2": "الكمبيوتر / الإنترنت / الاتصالات / إلكترونيات",
      "3": "التعليم / التدريب",
      "4": "الطاقة / المواد الخام",
      "5": "الخدمات المالية (المالية / المصرفية / التأمين)",
      "6": "الحكومة / القطاع الغير هادف للربح",
      "7": "الموارد البشرية",
      "8": "القانونية",
      "9": "التسويق",
      "10": "اللوجستية / النقل",
      "11": "الدوائية / الطبية",
      "12": "الخدمات المهنية",
      "13": "العقارات / الإنشاءات",
      "14": "صناعة الخدمات",
      "15": "التجارة / المستهلك / التصنيع / العمليات",
      "16": "غير ذلك (يرجى التحديد)"
    },
    "Annual_Income": "الدخل السنوي",
    "Annual_Income_word":"ويشمل ذلك جميع الدخل المكتسب بما في ذلك الأجور والمعاشات التقاعدية والفوائد والأرباح وإيرادات الإيجار وما إلى ذلك.",
    // "Total_Saving_Investments": "إجمالي المدخرات والاستثمارات (يشمل ذلك جميع حسابات البنك أو حسابات الوساطة المالية ، شهادات ، سندات ، استثمارات في أسواق المال ، إلخ)",
    "Total_Saving_Investments": "إجمالي الإدخار والإستثمارات",
    "Total_Saving_word": "وهذا يشمل جميع حسابات البنك أو الوساطة ، والشهادات ، والسندات ، والاستثمارات في سوق المال الخ.",
    "Total_Saving_Investments_select": {
      "0": "أكثر من 500000 دولار أمريكي",
      "1": "200000دولار - 499999 دولارًا أمريكيًا",
      "2": "100000 - 199999 دولارًا أمريكيًا",
      "3": "50000 دولار - 99999 دولارًا أمريكيًا",
      "4": "25000 إلى 49999 دولارًا أمريكيًا",
      "5": "10000 دولار - 24999 دولارًا أمريكيًا",
      "6": "2000 دولار - 9999 دولارًا أمريكيًا",
      "7": "أقل من 2000 دولار"
    },
    "liquidNetWorth": "صافي القيمة السائلة (باستثناء السكن الخاص)",
    "financialPortfolio": "قيمة محفظتك المالية",
    "annualIncomeSelect": {
      "0": "أكثر من 200000 دولار",
      "1": "100000 - 199999 دولارًا أمريكيًا",
      "2": "50000 دولار - 99999 دولارًا أمريكيًا",
      "3": "25000 إلى 49999 دولارًا أمريكيًا",
      "4": "10000 دولار - 24999 دولارًا أمريكيًا",
      "5": "أقل من 10000 دولار"
    },
    "fundsSource": "مصدر هذه الأموال",
    "fundsSourceSelect": {
      "0": "لا شيء",
      "1": "دخل الأسرة والشريك",
      "2": "الإعانات الحكومية",
      "3": "القرض / الائتمان",
      "4": "المعاش التقاعدي",
      "5": "الدخل من الأملاك",
      "6": "غير ذلك (يرجى التحديد)"
    },
    "Funds_Source": "مصدر آخر للدخل",
    "Intend_Deposit": "كم المبلغ الذي تنوي إيداعه؟",
    "intendDepositSelect": {
      "0": "أكثر من 100000 دولار أمريكي",
      "1": "80000 دولار - 99999 دولارًا أمريكيًا",
      "2": "50000 - 79999 دولارًا أمريكيًا",
      "3": "25000 دولار أمريكي - 49999 دولارًا أمريكيًا",
      "4": "10000 دولار - 24999 دولارًا أمريكيًا",
      "5": "أقل من 10000 دولار"
    },
    "Other_Industry_Sector": "الصناعات الأخرى / القطاع",
    "Other_Position": "مركز عملي آخر",
    "Other_Biz_Nature": "أخرى طبيعة الأعمال التجارية",
    "Other_Funds_Source": "مصدر آخر للدخل",
    "Afford_To_Lose_Error":"العقود مقابل الفروقات هي منتجات عالية المخاطر، ولهذا يجب عدم المتاجرة بأي أموال لا يمكنك تحمل تبعات خسارتها.",
    "Afford_To_Lose":" هل يمكنك تحمل تبعات خسارة الأموال التي تنوي استثمارها؟",
    "Afford_To_Lose_Select": {
      "Y": "نعم",
      "N": "لا"
    },
    "Open_Trading_Account":" لماذا تريد فتح حساب تداول مع ATFX؟",
    "Open_Trading_Account_Select": {
      "0": "المضاربة على المدى القصير والمتوسط في الأسواق المالية",
      "1": "التحوط على المدى القصير والمتوسط من الانكشاف على استثمارات قائمة",
      "2": "المضاربة على المدى القصير والمتوسط في الأسواق المالية والتحوط مقابل الانكشاف على استثمارات قائمة"
    },
    "ATFX_Client_Pro":"تعتبر ATFX أن منتجاتها مناسبة فقط للعملاء ذوي الأهداف المذكورة أعلاه، يرجى عدم الاستمرار في تقديم الطلب إذا كانت أهدافك تختلف عن تلك المذكورة أعلاه.",
    "Annual_Income_Total":"يرجى الإفصاح عن دخلك السنوي الفعلي",
    "Saving_Investments_Money":"يرجى الإفصاح عن إجمالي مدخراتك واستثمارك الفعلية",
  },
  "Experience": {
    "experienceLabel": "على مدى السنوات الثلاث الماضية ، إلى أي حد قمت بتداول الأدوات المالية التالية حيث قمت باتخاذ قرارات التداول بنفسك؟",
    "Futures_Options": "العقود الآجلة / خيارات",
    "Futures_Options_select": {
      "0": " لأكثر من 40 مرة",
      "1": "من 15 إلى 40 مرة",
      "2": "من مرة إلى 15 مرة",
      "3": "لا"
    },
    "CFDs_Spread_Bets": "عقودالفروقات ، مشتقات العملات الأجنبية أو الرهانات الموزعة",
    "CFDs_Spread_Bets_select": {
      "0": " لأكثر من 40 مرة",
      "1": "من 15 إلى 40 مرة",
      "2": "من مرة إلى 15 مرة",
      "3": "لا"
    },
    "Derivative_Trade_over2": "خلال الاثني عشر شهرًا الماضية ، هل قمت بعمل صفقتين لتداول العملات بالعقود الفورية على الأقل في كل ربع سنة  / العقود مقابل الفروقات / خيارات العقود الآجلة أو الرهانات الموزعة حيث قمت باتخاذ قرارات التداول الخاصة بك؟",
    "Derivative_Trade_over2_select": {
      "b": "نعم",
      "a": "لا"
    },
    "Derivative_Trade_over40": "خلال السنوات الثلاث الماضية ، هل أجريت أربعين صفقة في فترة اثني عشر شهرًا لأيا من المنتجات التالية : عقود العملات الفورية / عقود الفروقات / عقود الخيارات / العقود الآجلة أو الرهانات الموزعة؟",
    "Derivative_Trade_over40_select": {
      "b": "نعم",
      "a": "لا"
    },
    "Average_Annual_Investment":" ما هو المتوسط السنوي لحجم الاستثمارات في صفقاتك السابقة على المنتجات المالية التي حددتها أعلاه؟",
    "Average_Annual_Investment_select": {
      "0": "لم يسبق لي الاستثمار",
      "1": "أقل من 500$",
      "2": "يتراوح بين 500$ إلى 2,500$",
      "3": "يتراوح بين 2,500$ إلى 10,000$",
      "4": "أكثر من 10,000$"
    },
    "Average_Leverage_Level":" ما هو متوسط الرافعة المالية التي استخدمتها في تداول المنتجات المالية التي حددتها أعلاه؟",
    "Average_Leverage_Level_select": {
      "0": "لم يسبق لي استخدام الرافعة المالية",
      "1": "تصل إلى 1:10",
      "2": "تتراوح بين 1:10 – 1:25",
      "3": "تتراوح بين 1:25 – 1:50",
      "4": "تتراوح بين 1:50 – 1:100",
      "5": "أكبر من 1:100"
    }
  },
  "Knowledge": {
    "DT_Work_Experience": "هل سبق لك أن عملت في وظيفة تتطلب معرفة تداول المشتقات المالية بالرافعة المالية؟",
    "DT_Work_Experience_select": {
      "txt1": "نعم",
      "txt2": "لا",
      "subTxt1": "لدي خبرة عمل لا تقل عن 3 سنوات ،",
      "subTxt2": "لدي خبرة عمل أقل من 3 أعوام أو خبرة لعام واحد على الأقل في الاستثمار لحسابي الخاص."
    },
    "DT_Qualification": "هل حصلت على شهادة مؤهل منحك فهماً لتداول المشتقات المالية بالرافعة المالية؟",
    "DT_Qualification_select": {
      "txt1": "نعم",
      "txt2": "لا",
      "subTxt1": "أحمل مؤهلات أو درجات مهنية  مثل CFA أو MBA أو BSC أو MA",
      "subTxt2": "أحمل مؤهلاً أو درجة في المالية أو الاقتصاد أو المحاسبة أو في مجال مماثل"
    },
    "K_Sell_Position": "إذا كنت تبيع عقد واحد من الذهب (XAUUSD) بسعر 1200 ثم تحرك السوق إلى سعر 1300 ، فهل ستجني أو تخسر المال؟",
    "K_Sell_Position_b": "إذا كنت تبيع عقد واحد من الذهب (XAUUSD) بسعر 1200 ثم تحرك السوق إلى سعر 1300 ، فهل ستجني أو تخسر المال؟",
    "K_Sell_Position_select": {
      "0": "ستخسر",
      "1": "ستجني"
    },
    "Closing_Order": "لمنع حسابك من الخسارة أكثر من المبلغ المحدد مسبقًا.هل ستحد من خسارتك بوضع وقف الخسارة أو جني الأرباح؟ ",
    "Closing_Order_select": {
      "0": "إيقاف الخسائر",
      "1": "جني الأرباح"
    },
    "K_Profit_Change": "هل تفهم ، أنه كلما زادت الرافعة المالية  كلما إرتفعت المخاطر لرأس المال الخاص بك عند تداول منتجات CFD ذات الرافعة المالية؟",
    "K_Profit_Change_b": "هل تفهم ، أنه كلما زادت الرافعة المالية  كلما إرتفعت المخاطر لرأس المال الخاص بك عند تداول منتجات CFD ذات الرافعة المالية؟",
    "K_Profit_Change_select": {
      "0": "أفهم ذلك",
      "1": "لا أفهم ذلك"
    },
    "K_Margin": "ما هو الهامش المطلوب لتداول عقد واحد (100،000)  من زوج الدولار أمريكي / الين الياباني ، إذا كان الهامش الخاص بك هو 1:20 ؟",
    "K_Margin_select": {
      "0": "5000 دولار",
      "1": "50،000 دولار",
      "2": "100،000 دولار"
    }
  },
  "Acknowledgements": {
    "A1": "translation2.html:588  أؤكد أن المعلومات التي قدمتها دقيقة وكاملة، وأتعهد بإبلاغكم في حال طرأت أي تغييرات على هذه المعلومات.",
    "A2": "أقر بأنني قد قرأت وفهمت ووافقت على الالتزام بالاتفاقيات الموقعة مع AT Global Markets والتي قدمتها لي الشركة للاطلاع عليها.",
    "A2_txt": "اتفاقية العميل لدى AT Global Markets",
    "A2_link": "<a href='https://www.atfx.com/uk/wp-content/uploads/standard-terms-uk-en.pdf' target='_blank'> اتفاقية العميل لدى AT Global Markets </a>",
    "A3": "أقر بأنني قد قرأت وفهمت ووافقت على بيان الإفصاح عن المخاطر الذي قدمته AT Global Markets لي للاطلاع عليه",
    "A3_txt": "بيان الإفصاح عن المخاطر لدى AT Global Markets",
    "A3_link": "<a href='https://www.atfx.com/uk/wp-content/uploads/standard-terms-uk-en.pdf' target='_blank'> بيان الإفصاح عن المخاطر لدى AT Global Markets </a>",
    "A4": "أقر بأنني قد قرأت وفهمت ووافقت على سياسة تعارض المصالح وسياسة تنفيذ الأوامر الخاصة بـ AT Global Markets والتي قدمتها لي للاطلاع عليها.",
    "A4_txt": "سياسة تعارض المصالح وسياسة تنفيذ الأوامر لدى AT Global Markets",
    "A4_link": "<a href='https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Order%20Execution%20Policy%20EN%20-%20V10.18.pdf' target='_blank'> سياسة تنفيذ الأوامر </a> و <a href='https://www.atfx.com/uk/wp-content/uploads/conflict-of-interests-policy-uk-en.pdf' target='_blank'> سياسة تعارض المصالح </a> لدى AT Global Markets",
    "headaer": "أنت تؤكد من خلال تقديم هذا الإقرار بأنك على دراية بأن الفوركس وعقود الفروقات بالهامش هي منتجات يجري تداولها بالرافعة المالية، وبالتالي تمثل مخاطرة كبيرة على رأسمالك المستثمر. أنت تؤكد أيضاً على أن مسئولية مراقبة حسابك ستقع على عاتقك الشخصي، وأن طبيعة هذه المنتجات قد تؤدي إلى تكبد خسائر تزيد عن قيمة رأسمالك المستثمر.",
    "age": "أنت تؤكد أن عمرك 18 عاماً أو أكثر؛",
    "message": "أن المعلومات التي قدمتها في هذا الطلب صحيحة ودقيقة، وأنك تتعهد بإخطارنا في حال طرأت أي تغييرات على هذه المعلومات؛",
    "receive": {
      "text": "أنك قد قرأت وفهمت ووافقت على",
      "list": [
        "<a href='https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Standard%20Terms%20of%20Business%20EN%20-%20V08.18.pdf' target='_blank'>شروط الأعمال وتحذير ‏المخاطر ‏‎ </a>",
        "<a href='https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Order%20Execution%20Policy%20EN%20-%20V10.18.pdf' target='_blank'> سياسة تنفيذ الأوامر‏‎ </a>",
        "<a href='https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Privacy%20Notice%20EN%2031.08.pdf' target='_blank'> سياسة الخصوصية </a>",
        // "<a href='https://www.atfx.com/uk/wp-content/uploads/introducing-broker-disclosure-en.pdf' target='_blank'> إفصاح الوسيط المعرف </a>",
        "<a href='https://www.atfx.com/ar/legal' target='_blank'> وثيقة ‏المعلومات الأساسية‎ </a>"
      ]
    },
    "A_select": {
      "text": "أنك قد قرأت وفهمت ووافقت على",
      "Y": "نعم"
    },
    "checkboxTxt_A1": "لقد قرأت وفهمت وأوافق على جميع الشروط",
    "checkboxTxt_A2": "أتفهم أن عقود الفروقات هي منتجات ذات رافعة مالية وقد يكون أدائها متقلبًا",
    "checkboxTxt_A3": "أدرك أنه من مسؤوليتي مراقبة حسابي وإدارته",
    "checkboxTxt_A4": "أتفهم أنه عند تداول المنتجات ذات الرافعة المالية ، من الممكن أن تتخطى الخسائر حجم استثماري الأولي",
    "Marketing_Email_Preference": "أوافق على تلقي معلومات من ATFX والتي قد تحتوي على مواد تسويقية.",
    "Marketing_automatically": "لدى علم أنه يمكنني إلغاء الاشتراك في تلقي الاتصالات التسويقية على الفور من خلال الاتصال <a href='https://www.atfx.com/ar/about-us/contact-us' target='_blank'>بفريق خدمة العملاء</a>. *",
    "Marketing_Email_Preference_select":{
      "Y":"نعم",
      "N":"لا"
    },
    "Hear_ATFX":"كيف سمعت عن ATFX؟",
    "OtherHearATFX":"طرق أخرى",
    "hearATFXSelect":{
      "Recommendation":"توصية",
      "SearchEngine":"محرك البحث",
      "MediaAdvertising":"الإعلان الإعلامي",
      "Partnership":"شراكة",
      "Other":"آخر"
    },
    "Parent_IB_Code": "رمز المُحِيل",
    "Rec_Type": "نوع المُحِيل",
    "recTypeSelect": {
      "AA1": "AA1",
      "AA2": "AA2",
      "AA3": "AA3",
      "A01": "A01",
      "A02": "A02",
      "A03": "A03",
      "A00": "A00",
      "NAN": "لا يوجد مُحِيل"
    },
    "recGroup": "مجموعة المُحِيل",
    "recGroupSelect": {
      "A": "A",
      "AA": "AA"
    },
  },
  "customErrMsg": {
    "fieldIsRequired": {
      "Gender": "يرجى الاختيار",
      "OtherGender":"يرجى إدخال جنس آخر",
      "Title": "يرجى الاختيار",
      "OtherTitle":"يرجى إدخال عنوان آخر",
      "First_Name": "الاسم الأول",
      "Surname": "اللقب",
      "Email": "البريد الإلكتروني",
      "Email_Confirm": "تأكيد عنوان البريد الإلكتروني",
      "Lang": "يرجى الاختيار",
      "Country": "البلد/المنطقة",
      "MT4_Currency":"البلد/المنطقة",
      "Account_Type":"البلد/المنطقة",
      "Addr": "العنوان",
      "Addr2": "سطر العنوان 2",
      "City": "المدينة",
      "Postcode": "الرمز البريدي",
      "Building_Name": "رقم المبنى / الاسم",
      "Street": "شارع",
      "Province": "مقاطعة",
      "Birth_Date_Year": "تاريخ الميلاد",
      "Birth_Date_Month": "تاريخ الميلاد",
      "Birth_Date_Second": "تاريخ الميلاد",
      "Nationality": "الجنسية",
      "isHavePass": "يرجى الاختيار",
      "NAT_ID": "جواز السفر",
      "Phone": "الهاتف",
      "Doc_Type": "يرجى الاختيار",
      "Doc_No": "رقم بطاقة الهوية",
      "Addr_Country": "يرجى الاختيار",
      "Bank_Card_No": "رقم البنك",
      "Bank": "البنك",
      "OtherBank": "بنوك أخرى",
      "Beneficiary_Name": "اسم المستفيد",
      "Branch_Name": "اسم الفرع",
      "Bank_Addr": "عنوان الفرع",
      "Branch_Province": "مقاطعة الفرع",
      "Branch_City": "مدينة الفرع",
      "FD_Emp_Status": "يرجى الاختيار",
      "FD_Position": "الوظيفة",
      "FD_Employer": "اسم الشركة",
      "FD_Biz_Nature": "يرجى إدخال سمات النشاط التجاري",
      "FD_FCA_AUTH": "الرجاء",
      "FD_Annual_Income": "يرجى الاختيار",
      "FD_Liquid_Net_Worth": "يرجى الاختيار",
      "FD_Portfolio_Value": "يرجى الاختيار",
      "FD_Funds_Source": "يرجى الاختيار",
      "FD_Funds_Other": "يرجى الاختيار",
      "E_Forex_Exp": "يرجى الاختيار",
      "E_Forex_Trade_No": "يرجى الاختيار",
      "E_Derivative_Exp": "يرجى الاختيار",
      "E_Derivative_Trade_No": "يرجى الاختيار",
      "E_Equity_Exp": "يرجى الاختيار",
      "E_Equity_Trade_No": "يرجى الاختيار",
      "K_A": "هل سبق لك العمل في وظيفة تتطلب خبرة بتداول المشتقات؟",
      "K_A_Detail": "تفاصيل",
      "K_B": "هل سبق لك حضور أي دورات تدريبية أو ندوات حول تداول المشتقات المالية؟",
      "K_B_Detail": "تفاصيل",
      "K_C": "هل حصلت على أي مؤهلات تسمح لك بفهم طبيعة تداول المشتقات المالية؟",
      "K_C_Detail": "تفاصيل",
      "K_D": "هل تفهم مخاطر وآليات التداول بالرافعة المالية، وأن أي تحركات طفيفة في سعر الأصل الأساسي قد تؤدي إلى تغيرات كبيرة في قيمة محفظتك الاستثمارية؟",
      "K_E": "هل أنت على دراية بأنك قد تتكبد خسارة تزيد عن قيمة رأسمالك المبدئي؟",
      "K_F": "هل تفهم أن ATFX هي الطرف المقابل في جميع صفقاتك وأنك ستحتاج إلى إغلاق صفقتك مع شركتنا، وبالتالي ستكون معرض للانكشاف على مخاطرها الائتمانية؟",
      "K_G": "هل تفهم أنه إذا تحركت الأسواق في غير صالحك، فسوف تكون بحاجة إلى إيداع هامش إضافي خلال مهلة قصيرة، وأن الفشل في الحفاظ على مستويات الهامش المطلوب قد يؤدي إلى إغلاق صفقاتك بطريقة أوتوماتيكية؟",
      "K_H": "هل تفهم أن أوامر وقف الخسارة لا تضمن بالضرورة تقليل المخاطر التي تواجهها، وأنك معرض في الأسواق سريعة الحركة لحدوث انزلاق سعري قد يؤدي إلى إغلاق الصفقة عند مستوى يتجاوز سعر الإيقاف؟",
      "A1": "translation2.html:588  أؤكد أن المعلومات التي قدمتها دقيقة وكاملة، وأتعهد بإبلاغكم في حال طرأت أي تغييرات على هذه المعلومات.",
      "A2": "أقر بأنني قد قرأت وفهمت ووافقت على الالتزام بالاتفاقيات الموقعة مع AT Global Markets والتي قدمتها لي الشركة للاطلاع عليها.",
      "A3": "أقر بأنني قد قرأت وفهمت ووافقت على بيان الإفصاح عن المخاطر الذي قدمته AT Global Markets لي للاطلاع عليه",
      "A4": "أقر بأنني قد قرأت وفهمت ووافقت على سياسة تعارض المصالح وسياسة تنفيذ الأوامر الخاصة بـ AT Global Markets والتي قدمتها لي للاطلاع عليها.",
      "checkList": "يرجى الاختيار",
      "Emp_Status": "يرجى الاختيار",
      "Freelance_OwnACompany": "يرجى الاختيار",
      "Industry_Sector": "يرجى الاختيار",
      "Position": "يرجى الاختيار",
      "Employer": "اسم الشركة",
      "Biz_Nature": "يرجى إدخال سمات النشاط التجاري",
      "Annual_Income": "يرجى الاختيار",
      "Total_Saving_Investments": "يرجى الاختيار",
      "Funds_Source": "يرجى الاختيار",
      "Intend_Deposit": "يرجى الاختيار",
      "Other_Industry_Sector": "صناعة أخرى/القطاع",
      "Other_Position": "وظيفة أخرى",
      "Other_Biz_Nature": "أخرى طبيعة الأعمال التجارية",
      "Other_Funds_Source": "مصدر آخر للدخل",
      "Futures_Options": "يرجى الاختيار",
      "CFDs_Spread_Bets": "يرجى الاختيار",
      "Derivative_Trade_over2": "يرجى الاختيار",
      "Derivative_Trade_over40": "يرجى الاختيار",
      "DT_Work_Experience": "يرجى الاختيار",
      "DT_Qualification": "يرجى الاختيار",
      "K_Sell_Position": "يرجى الاختيار",
      "Closing_Order": "يرجى الاختيار",
      "K_Profit_Change": "يرجى الاختيار",
      "K_Margin": "يرجى الاختيار",
      "IBAN_Code":"يرجى إدخال رمز IBAN",
      "Hear_ATFX":"يرجى الاختيار",
      "OtherHearATFX":"من فضلك ادخل",
      "Rec_Type":"يرجى الاختيار",
      "Parent_IB_Code":"رمز المُحِيل",
      "Afford_To_Lose":"يرجى الاختيار",
      "Open_Trading_Account":"يرجى الاختيار",
      "Annual_Income_Total":"يرجى الإدخال",
      "Saving_Investments_Money":"يرجى الإدخال",
      "IS_Politically_Person":"يرجى الاختيار",
      "isDualCitizenship":"يرجى الاختيار",
    }
  },
  "errors": {
    "fieldIsRequired": "عنوان البريد الإلكتروني",
    "invalidFormat": "تنسيق خاطئ!",
    "numberTooSmall": "الرقم صغير جداً! الحد الأدنى: {0}",
    "numberTooBig": "الرقم كبير جداً! الحد الأقصى: {0}",
    "invalidNumber": "رقم خاطئ",
    "textTooSmall": "طول النص صغير جداً! الحالي: {0}، الحد الأدنى: {1}",
    "textTooBig": "طول النص كبير جداً! الحالي: {0}، الحد الأقصى: {1}",
    "thisNotText": "هذا ليس نصاً!",
    "thisNotArray": "هذه ليست مصفوفة!",
    "selectMinItems": "اختر الحد الأدنى {0} من العناصر!",
    "selectMaxItems": "اختر الحد الأقصى {0} من العناصر!",
    "invalidDate": "تاريخ خاطئ!",
    "dateIsEarly": "التاريخ مبكرا جداً! الحالي: {0}، الحد الأدنى: {1}",
    "dateIsLate": "التاريخ قديم جداً! الحالي: {0}، الحد الأقصى: {1}",
    "invalidEmail": "عنوان البريد الإلكتروني غير متوفر!",
    "invalidURL": "رابط URL خاطئ!",
    "invalidCard": "تنسيق البطاقة خاطئ!",
    "invalidCardNumber": "رقم البطاقة خاطئ!",
    "invalidTextContainNumber": "نص غير صالح! لا يمكن أن يحتوي النص على أرقام أو أحرف خاصة",
    "invalidTextContainSpec": "نص غير صالح! لا يمكن أن يحتوي النص على أحرف خاصة",
    "incorrectComfirm": "كلا المدخلين غير متناسقين",
    "invalidBirthDate": "يجب أن يتراوح العمر بين 18-69 فقط",
    "invalidParentClnID": "يرجى إدخال عدد أقل من 12 رقم!",
    "docImgFrontSizeLimit": "يجب ألا يتجاوز حجم صورة بطاقة الهوية (الوجه الامامي) 2 ميجابايت!",
    "docImgBackSizeLimit": "يجب ألا يتجاوز حجم صورة بطاقة الهوية (الوجه الخلفي) 2 ميجابايت!",
    "imgSizeLimit": "يجب ألا يتجاوز حجم صورة إثبات العنوان 2 ميجابايت.",
    "bankCardNoTopTwo": "يقع أول رقمين من أرقام البطاقة المصرفية خارج الخط",
    "bankCardNoLnegth": "يرجى إدخال رقم من 16-19",
    "dayErrors1": "هذه السنة كبيسة، ولا يوجد يوم",
    "dayErrors2": "سنته لهذه السنة، لا يوجد هذا اليوم",
    "dayErrors3": "لا يوجد هذا اليوم في هذا الشهر",
    "emailError": "عنوان البريد الإلكتروني غير متوفر",
    "DocTypeNoError": "رقم بطاقة الهوية غير قانوني",
    "DocFrontImg": "يرجى رفع صورة لبطاقة الهوية (الوجه الأمامي)",
    "DocBackImg": "يرجى رفع صورة لبطاقة الهوية (الوجه الخلفي)",
    "ProofofAddress": "يرجى رفع صورة لإثبات العنوان",
    "Doc_No": "رقم بطاقة الهوية",
    "Phone": "الهاتف",
    "Bank_Card_No": "رقم البنك",
    "Birth_Date_Second": "تاريخ الميلاد",
    "phoneError": "تنسيق رقم الهاتف غير صحيح",
    "bankNumError": "تنسيق رقم البنك غير صحيح",
    "numType": "الرجاء إدخال رقم",
    "bankCodeError":"تنسيق ترميز IBAN غير صحيح"
  },
  "messages": {
    "fieldsWillBeReset": "سيتم إعادة تعيين جميع المدخلات، يرجى التأكيد",
    "completeTip1": "يرجى التحقق من بريدك الإلكتروني. شكراً لك.",
    "completeTip2": "اكتملت! شكراً لك.",
    "noCompleteTip": "للأسف، المعلومات التي أدخلتها غير صحيحة ولهذا فشلت العملية أعلاه",
    "emailAndDocInvalid": "عنوان البريد الإلكتروني مستخدم بالفعل",
    "phoneAndDocInvalid": "رقم الهاتف مستخدم بالفعل",
    "IBCodeInvalid": "رمز المحيل خاطئ",
    "invalidBankCardNo": "رقم البطاقة المصرفية خاطئ. يرجى التحقق من الرقم قبل تقديمه",
    "beneficiaryName": "أسم المستفيد",
    "employerName": "اسم صاحب العمل",
    "errors": "أخطاء الشبكة",
    "unSelect":"يرجى الاختيار",
    "selectEmpStatusTip":"حالة عملك تظهر أنك متقاعد / طالب / عاطل عن العمل. تداول العملات الأجنبية (الفوركس) وعقود الفروقات (CFDs) هي أدوات مضاربية للغاية وتحمل درجة عالية من المخاطرة برأس مالك الخاص.لحماية مصالحك المباشرة ، سنراجع مدى ملاءمتك للمنتجات التي نقدمها استنادًا إلى المستندات الداعمة التي تقدمها والتي تؤكد أرصدتك من التوفير / الميراث المذكور في طلبك. "
  },
  "ModalMsg": {
    "showModal": {
      "content": "Based on the information you provided on your AT Global Markets Limited (UK) Limited client account application, it is necessary for us to inform you that trading in CFDs and leveraged forex may not be appropriate for you. Leveraged trading carries a high degree of risk to your capital. The Company provides an execution-‐‐only service to its clients and you will need to rely upon your own skill and judgement when trading these markets. <br/><br/><b>Please note: AT Global Markets (UK) Limited oﬀers demo accounts where you can practice trading against realistic market prices and the Company would encourage you to try this before trading with real money.</b><br/><br/>If you still wish to open a client account with AT Global Markets (UK) Limited, please conﬁrm this by accepting the statement below.",
      "checkboxTxt":"I understand that trading in CFDs and leveraged forex trading carries a high degree of risk to my capital. I am able to assess the risks involved and wish to continue with my application to open an account.",
      "errorsTxt": "يرجى الاختيار",
      "btn": "تأكيد"
    },
    "showAlert": {
      "title": "تلميح:",
      "submitBtnTxt": "تأكيد",
      "cancleBtnTxt": "إلغاء الأمر",
      "confirmBtnTxt": "تأكيد"
    }
  },
  "ratesModalMsg": {
    "p3_1": "تنبيه - تغييرات معدل الهامش لجميع المتداولين من عملاء التجزئة",
    "p3_2": "عزيزنا مقدم الطلب ،",
    "p3_2_1": "",
    "p3_3": "يرجى ملاحظة أنه بسبب تغييرات هيئة الأوراق المالية والأسواق الأوروبية (ESMA) للعملاء من متداولوا التجزئة ، فإن جميع عملاء ATFX الجدد بدءاً من 2 يوليو 2018 سيستخدمون معدلات الهامش الجديدة.",
    "p3_4": "وتشمل التغييرات الحد الأقصى لمقدار الرافعة المالية التي يمكن تقديمها لعملاء التجزئة.",
    "p4_1": "أزواج العملات الرئيسية: أزواج العملات التي تحتوي على أي اثنتين مما يلي: الدولار الأمريكي ، اليورو ، الين الياباني ، الجنيه الإسترليني ، الدولار الكندي ،الفرنك السويسري - 3.33 ٪ (الرافعة المالية 30: 1)",
    "p4_2": "أزواج العملات الفرعية: جميع أزواج العملات الأخرى - 5٪ (الرافعة المالية 20: 1)",
    "p4_3": "المؤشرات الرئيسية لأسواق الأسهم: UK100 ، FRA40 ، ESP35 ، US30 ، SPX500 ، NAS100 ، JP225 ، AUS200 - 5% (الرافعة المالية 1:20)",
    "p4_4": "الذهب: 5 ٪ (الرافعة المالية 20: 1)",
    "p4_5": "السلع الأخرى: 10 ٪ (الرافعة المالية 10: 1)",
    "p5_1": "توفير الحماية ضد الأرصدة السالبة ",
    "p5_2": "قدمت هيئة الأوراق المالية والأسواق الأوروبية (ESMA) قاعدة جديدة لضمان عدم خسارة المتداولون جميعا من عملاء التجزئة أكثر من الأموال المتاحة للتداول في حساباتهم.  فإذا كان رصيدك سالبًا ، فسيتم إلزام ATFX بإرجاع رصيدك إلى الصفر - دون تحمل العميل أي تكلفة.",
    "p5_3": "قاعدة الإغلاق الإلزامي عند 50 ٪ لمستوى الهامش",
    "p5_4": "تطبق  ATFX الآن بالفعل قاعدة الإغلاق الجبرى للمراكز عند وصول مستوى الهامش إلى نسبة 50% لجميع العملاء.",
    "p5_5": "إذا كنت ترغب في إنهاء طلبك وفتح حساب ATFX لعملاء التجزئة ، يرجى التأشيربعلامة المربع الموضح بالأسفل.",
    "p5_6": "أقر وأوافق على الشروط الجديدة لعملاء التجزئة",
    "p6_2": "يرجى الموافقة ",
    "btnText": "إرسال"
  }
}



// WEBPACK FOOTER //
// ./src/lang/ar.js